import { Affix, Divider, Form, Input, Select, Space, Table, Typography, Modal, Button } from 'antd'
import { Badge, Col, Row } from 'reactstrap'
import { Group, OrderModel } from './models/Order'
import MultipleEditModal, { MultipleEditModalHandle } from './modals/EditModal/multiple'
import { OrderForm, OrderPost } from '../orders/models/Order'
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { createRef, useEffect, useRef, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { RootState } from 'setup'
import { actions } from './redux/OrdersRedux'
import { debounce } from 'lodash'
import moment from 'moment'
import { postWithoutTokenFunciton } from 'utils/ApiHelper'
import { useHistory } from 'react-router-dom'
import { format } from 'utils/convert'
import { ROLE_GENERAL, generalVietnameseDateFormat } from 'utils/constants'
type Props = {
  className: string
  orders: OrderModel[]
  state: string
  apiAlias: string
}

const OrderList: React.FC<Props> = ({ apiAlias, className, orders, state }) => {
  const editMultipleModal = useRef<MultipleEditModalHandle>(null)
  const history = useHistory()
  const dispatch = useDispatch()
  const [groupName, setGroupName] = useState('')
  const role: string =
    (useSelector<RootState>(({ auth }) => auth.user?.role, shallowEqual) as string) || ''
  const groups: Group[] =
    (useSelector<RootState>(({ orders }) => orders.groups, shallowEqual) as Group[]) || []
  const [currentGroup, setCurrentGroup] = useState<Group>()
  const [currentChannelID, setCurrentChannelID] = useState('')
  const loading: boolean =
    (useSelector<RootState>(({ orders }) => orders.loading, shallowEqual) as boolean) || false
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  let defaultDate = new Date()
  defaultDate.setDate(defaultDate.getDate() + -7)
  const [currentCancelChannel, setCurrentCancelChannel] = useState('')
  console.log('loading', loading)

  useEffect(() => {
    //dispatch(c.requestAccounts(1))
  }, [])


  useEffect(() => {
    if (!loading) {
      setCurrentCancelChannel('');
    }

    return () => {};
  }, [loading])


  const clickUpdateHandler = (item: OrderModel) => {
    dispatch(actions.refreshRequest(item.channel_id||''))
  }

  const clickDeleteHandler = (item: OrderModel) => {
    if (window.confirm('bạn có chắc chắn muốn xóa đơn này') === true) {
      dispatch(actions.deleteOrderRequest(item.channel_id || ''))
    }
  }

  const editVideo = (channel_id:string) => {
    if (editMultipleModal && editMultipleModal.current) {
      editMultipleModal.current.showModal(channel_id, true, (data) => {
        console.log('data update', data)
        setSelectedRowKeys([])
        dispatch(actions.requestOrders(state))
      })
    }
  }

  const deleteOrders = async (channelIds: string[]) => {
    try {
      const params: OrderPost[] = channelIds.map((channel_id) => {
        return {
          tab_run: 0,
          priority: 0,
          group_id: -1,
          note: '',
          subscribe_need: 0,
          channel_id: channel_id,
          like_need: 0,
          video_id: channel_id,
          enabled: 0,
        }
      })
      const apiAlias = window.apiAlias || 'subscribe'
      let res = await postWithoutTokenFunciton(`${apiAlias}/deleteMulti`, params)
      if (res?.data?.status === 'success') {
        setSelectedRowKeys([])
        dispatch(actions.requestOrders(state))
      }
    } catch (e: any) {
      alert(`Update failed ${e.message}`)
    }
  }
  const deleteMultiple = () => {
    if (editMultipleModal && editMultipleModal.current) {
      const selectedKeys: string[] = []
      selectedRowKeys.forEach((value: React.Key) => {
        selectedKeys.push(value.toString())
      })
      if (window.confirm('bạn có chắc chắn muốn xóa đơn này') == true) {
        // @ts-ignore
        deleteOrders(selectedRowKeys)
      }
    }
  }
  const addGroup = () => {
    if (groupName.length === 0) {
      alert('vui lòng điền tên nhóm')
      return
    }
    dispatch(actions.addGroupRequest(groupName))
    setGroupName('')
  }


  const searchByChannelID = (e: React.ChangeEvent<HTMLInputElement>) => {
    debounce(() => {
      setCurrentChannelID(e.target.value)
    }, 1000)()
  }

  const remapOrders: OrderModel[] = orders.filter((order: OrderModel, index: number) => {
    if (currentGroup !== undefined && order.group_id !== currentGroup.id) {
      return false
    }
    if (currentChannelID && order.channel_id !== currentChannelID) {
      return false
    }

    return true
  })


  let totalRuned = 0
  remapOrders.forEach((item) => {
    totalRuned = totalRuned + (item.current_view - item.start_view)
  })

  const onNameChange = (event: any) => { }

  const addItem = (e: any) => {
    e.preventDefault()
  }

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log('selectedRowKeys changed: ', selectedRowKeys)
    setSelectedRowKeys(newSelectedRowKeys)
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  }



  const hasSelected = selectedRowKeys.length > 0

  return (
    <div className='c-order'>
      <div className='page-header'>
        <div className='page-header__content'>
          <Row className='align-items-center'>
            <div className='col-lg-10 col-sm-12 c-order__header'>
              <span className='fw-bolder fs-3 mb-1'>
                <span className='fw-bolder fs-3 mb-1'>Đơn Đang Chạy</span>
                <span className='text-danger ml-2 fw-bold fs-7'>
                  ({format(orders.length, 0, 3)}){' Kênh '}
                </span>
              </span>
            </div>
            <div className='col-lg-2 col-sm-12 text-center'>
              <div className='card-toolbar d-block'>
                <button
                  onClick={() => {
                    history.push(`/page/${apiAlias}Orders/create`)
                  }}
                  className='btn btn-sm btn-danger'
                >
                  <FontAwesomeIcon icon={['fas', 'plus']} />  Thêm Kênh
                </button>
              </div>
            </div>
          </Row>
        </div>
      </div>
      <div className={`card ${className}`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <div className='card-toolbar justify-content-between'></div>
          <div className='card-toolbar justify-content-between'>
            <div className='card-toolbar w-100'>
              <Form layout='vertical' className='w-100'>
                <div className='row'>
                  <div className='col'>
                    <div className='row'>
                      <div className='col'>
                        <div className='row'>
                          <div className='col-12'>
                            <Form.Item
                              label={`Tìm theo ID kênh `}
                              className='mb-0'
                            >
                              <Input
                                placeholder={`Nhập UID kênh ...`}
                                onChange={searchByChannelID}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        <div className='card-body py-3'>
          {/* begin::Table container */}
          <div className='table-responsive '>
            <div >
              {
               /*
                <Affix offsetTop={10}>
                  <div style={{ marginBottom: 16, background: '#fff' }} className='c-order__nav'>
                    <button
                      disabled={!hasSelected}
                      onClick={editMultiplePriority}
                      className='btn btn-sm btn-primary'
                    >
                      <FontAwesomeIcon icon={['far', 'edit']} /> Cài đặt ưu tiên
                    </button>
                    <span style={{ marginLeft: 8 }}>
                      {hasSelected ? `Selected ${selectedRowKeys.length} items` : ''}
                    </span>

                  </div>
                </Affix>
               */
              }
              <Table
                loading={loading}
                bordered
                pagination={false}
                rowSelection={rowSelection}
                columns={[
                  {
                    title: '#',
                    key: 'stt',
                    dataIndex: 'stt',
                    width: 40,
                    render: (value: any, record: OrderModel, index: any) => index + 1,
                  },
                  {
                    title: `Channel`,
                    key: 'channel_id',
                    dataIndex: 'channel_id',
                    width: 100,
                    render: (value: any, item: OrderModel, index: any) => {
                      return (
                        <>
                          <a
                            href={'https://www.youtube.com/channel/' + item.channel_id}
                            className='text-dark fw-bolder text-hover-primary text-sm'
                          >
                            {item.channel_id}
                          </a>
                        </>
                      )
                    },
                  },
                  {
                    title: 'Ngày Thêm',
                    key: 'datetime',
                    width: 150,
                    dataIndex: 'datetime',
                    render: (value: any, item: OrderModel, index: any) => {
                      return (
                        <>
                          {moment(item.date_insert).format(generalVietnameseDateFormat)}
                          <span
                            style={{ fontSize: '12px' }}
                            className=' fw-bold  d-block'
                          ></span>
                        </>
                      )
                    },
                  },
                  {
                    title: "Đã chạy",
                    key: 'totalRun',
                    dataIndex: 'totalRun',
                    width: 200,
                    render: (value: any, item: OrderModel, index: any) => {
                      const subRun = item.current_view - item.start_view
                      return (
                        <>
                          <span
                            style={{ fontSize: '12px' }}
                            className={
                              ' fw-bold  d-block font-size-10 ' +
                              (subRun > 0 ? 'text-warning' : 'text-primary')
                            }
                          >
                            {format(Math.abs(subRun) || 0, 0, 3)}
                          </span>
                        </>
                      )
                    },
                  },
                  {
                    title: 'View Bắt Đầu',
                    key: 'sub_start',
                    width: 200,
                    render: (value: any, record: OrderModel, index: any) => {
                      return format(record.start_view || 0, 0, 3)
                    },
                  },
                  {
                    title: 'Videos',
                    key: 'video',
                    width: 200,
                    render: (value: any, record: OrderModel, index: any) => {
                      return format(record.videos || 0, 0, 3)
                    },
                  },
                  {
                    title: 'View Hiện Tại',
                    key: 'sub_start',
                    width: 200,
                    render: (value: any, record: OrderModel, index: any) => {
                      return format(record.current_view || 0, 0, 3)
                    },
                  },
                  {
                    title: 'Đang chạy',
                    key: 'sub_start',
                    width: 200,
                    render: (value: any, record: OrderModel, index: any) => {
                      return format(record.threads || 0, 0, 3)
                    },
                  },
                  {
                    ...((role === ROLE_GENERAL.ADMIN || role === ROLE_GENERAL.SUPER_ADMIN)
                      ? {
                        title: 'Lần cuối',
                        key: 'last_get',
                        render: (value: any, record: OrderModel, index: any) => {
                          return `${moment(record.last_get).format('DD/MM HH:mm')}`
                        },
                      }
                      : { width: 1 }),
                  },
                  {
                    title: 'update',
                    key: 'last_update',
                    render: (value: any, record: OrderModel, index: any) => {
                      return `${moment(record.last_update).format('DD/MM HH:mm')}`
                    },
                  },
                  {
                    width: 90,
                    title: '---',
                    key: 'running',
                    render: (value: any, record: OrderModel, index: any) => {
                      return (
                        <>
                          <div className='d-flex flex-direction-column'>
                            <Button
                              onClick={() => clickUpdateHandler(record)}
                              className='c-order__btn c-order__btn--edit'
                            >
                              <i className="feather icon-edit"></i> Refresh
                            </Button>
                            <Button
                              onClick={() => clickDeleteHandler(record)}
                              className='c-order__btn c-order__btn--trash'
                            >
                              <i className="feather icon-trash-2"></i> Trash
                            </Button>
                          </div>
                        </>
                      )

                    },
                  },
                  {
                    width: 90,
                    title: '---',
                    key: 'running',
                    render: (value: any, record: OrderModel, index: any) => {
                      return (
                        <>
                          <div className='d-flex flex-direction-column'>
                            <Button
                              onClick={() => editVideo(record.channel_id||'')}
                              className='c-order__btn c-order__btn--edit'
                            >
                              <i className="feather icon-plus"></i> Videos
                            </Button>
                          </div>
                        </>
                      )
                    },
                  },
                ]}
                rowKey={(record) => record.channel_id || 1}
                dataSource={remapOrders}
              />
            </div>
          </div>
          {/* end::Table container */}
        </div>
        <MultipleEditModal ref={editMultipleModal} />
      </div>
    </div>
  )
}

export { OrderList }
